import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HeroSlider.css';

const HeroSlider = ({ events }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        // Reset currentSlide when events change
        setCurrentSlide(0);
        
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % events.length);
        }, 5000);

        // Cleanup timer on unmount or when events change
        return () => clearInterval(timer);
    }, [events]); // Added events as a dependency

    const handleTicketClick = (event) => {
        navigate(`/event/${event.id}`);
    };

    if (!events || events.length === 0) {
        return null;
    }

    return (
        <div className="hero-slider">
            <div 
                className="slides" 
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
                {events.map((event, index) => (
                    <div 
                        key={`slide-${event.id}-${index}`} 
                        className="slide"
                    >
                        <img 
                            src={event.image_url} 
                            alt={event.title}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = '/placeholder-event.jpg';
                            }}
                        />
                        <div className="slide-content">
                            <h1>{event.title}</h1>
                            <p>{event.description}</p>
                            <div className="slide-buttons">
                                <button 
                                    className="get-tickets-btn"
                                    onClick={() => handleTicketClick(event)}
                                >
                                    Bilet Al
                                </button>
                                <button 
                                    className="view-details-btn"
                                    onClick={() => navigate(`/event/${event.id}`)}
                                >
                                    Detaylar
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HeroSlider; 